import { VoucherFormData } from './voucher.types';

export const GENERIC_ERROR = 'Something went wrong. Please try again.';
export const EMPTY_EMAIL_ERROR = 'No email provided';
export const INVALID_EMAIL_ERROR = 'Invalid email';
export const EMPTY_RECAPTCHA_ERROR = 'Uh oh! Please fill out the captcha!';

export const DEFAULT_MONTHS = 6;
export const DEFAULT_SUBSCRIPTIONS = 3;

export const GBP = 'gbp' as const;
export const USD = 'usd' as const;

export const DEFAULT_AUTH_VALUES: VoucherFormData = {
  email: null,
  months: DEFAULT_MONTHS,
  subscriptions: DEFAULT_SUBSCRIPTIONS,
  currency: null,
};

export const DEFAULT_NO_AUTH_INPUT_VALUES: VoucherFormData = {
  email: '',
  months: DEFAULT_MONTHS,
  subscriptions: DEFAULT_SUBSCRIPTIONS,
  currency: USD,
};
